module.exports = __webpack_public_path__ + "img/switch-from-to-icons.eab80409.svg";